/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import { createModuleAction, createReducer } from 'redux-app/utils/reducer'

const createAction = createModuleAction('PAGE_SCROLLER')

export const setScrollElementId = createAction('SET_SCROLL_ELEMENT_ID')

const ACTION_HANDLERS = {
  [setScrollElementId.toString()]: (state, { payload }) => payload,
}

const initialState = null

export default createReducer(initialState, ACTION_HANDLERS)
